import { useContext } from 'react';
import { Textbox, Textarea } from 'components/generic';
import { WorkflowContext } from 'providers/workflow-provider';
import { cloneDeep } from 'lodash';
import './styles.scss';

export default function RuleModal(props) {
	const context = useContext(WorkflowContext);
	const { wfConditions, setWfConditions } = context;

	// handle input for name and description
	const handleInput = (e, key) => {
		setWfConditions(prevState => {
            const state = cloneDeep(prevState)
			state[key] = e?.target?.value;
			return state;
		});
	};

	return (
		<div className='modal'>
			<Textbox label='Name' placeholder='Name' value={wfConditions?.wfc_name} onChange={e => handleInput(e, 'wfc_name')} />
			<Textarea label='Description' placeholder='Description' value={wfConditions?.wfc_description} onChange={e => handleInput(e, 'wfc_description')} />
		</div>
	);
}
